export enum TypVelikostiSouboru {
	DECIMALNI = 'DECIMALNI',
	BINARNI_IEC = 'BINARNI_IEC'
}
